import Vue from 'vue'

export default el => Promise.all([
  enqueueModule('contact-form.vue'),
  enqueueModule('text-area.vue'),
  enqueueModule('text-input.vue')
])
  .then(() => new Vue({ el }))
